import { DeviceHub } from '@material-ui/icons';
import { CsvImportButton } from '../../../../CsvImportButton';
import React from 'react';
import { useCreateOperator } from '../../../../../../contexts/CreateOperatorContext';
import { CollapsableContent } from '../../../../../../components/CollapsableContent/CollapsableContent';
import { DynamicForm } from '../../../DynamicForm';
import { SettingItemList } from '../../../SettingItemList';
import { RoutingGroup } from './RoutingGroup';

export const RoutingGroups = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  if (operator.mediaFirstSettings === undefined) return null;

  const handleRemovePkg = (rgIndex: number) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        routingGroups: (
          operator.mediaFirstSettings?.routingGroups ?? []
        ).filter((value, index) => index !== rgIndex),
      })
    );
  };

  const handleSavePkg = (item: CreateExperienceGroup, rgIndex: number) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        routingGroups: (operator.mediaFirstSettings?.routingGroups ?? []).map(
          (value, index) => {
            if (index === rgIndex) return item;
            return value;
          }
        ),
      })
    );
  };
  return (
    <CollapsableContent
      icon={<DeviceHub />}
      header={<p>Routing Groups</p>}
      count={(operator.mediaFirstSettings?.routingGroups ?? []).length}
      customAction={
        <CsvImportButton
          canOverwrite={true}
          settingName="Routing Groups"
          requiredColumns={[
            { name: 'description', type: 'string' },
            { name: 'mediafirstId', type: 'string' },
          ]}
          onImport={(csv, overwrite) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                routingGroups: overwrite
                  ? csv
                  : [
                      ...csv,
                      ...(operator.mediaFirstSettings?.routingGroups ?? []),
                    ],
              })
            )
          }
        />
      }
      padding="sm"
    >
      <div className={classes.container}>
        <DynamicForm<CreateRoutingGroup>
          defaultForm={{
            active: true,
            description: '',
            mediafirstId: '',
          }}
          inputs={[
            {
              order: 0,
              rowInputs: [
                {
                  props: {
                    name: 'description',
                    label: 'Description',
                    required: false,
                    value: (values) => values.description,
                  },
                },
                {
                  props: {
                    name: 'mediafirstId',
                    label: 'MediaFirst ID',
                    required: false,
                    value: (values) => values.mediafirstId,
                  },
                },
              ],
            },
          ]}
          submitButton={{ text: 'Add Routing Group' }}
          validation={(values) =>
            (values.description ?? '').trim() !== '' &&
            (values.mediafirstId ?? '').trim() !== ''
          }
          onSubmit={(values) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                routingGroups: [
                  values,
                  ...(operator.mediaFirstSettings?.routingGroups ?? []),
                ],
              })
            )
          }
        />
        <SettingItemList<CreateRoutingGroup>
          name="Routing Groups"
          items={operator.mediaFirstSettings?.routingGroups ?? []}
          renderRow={(item, index) => (
            <RoutingGroup
              index={index}
              routingGroup={item}
              onRemove={handleRemovePkg}
              onSave={handleSavePkg}
            />
          )}
        />
      </div>
    </CollapsableContent>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-4 items-center w-full',
  inputs: 'inline-flex items-center gap-4',
});
